import React, { useContext, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { authContext } from '../../configurations/auth/authContext';
import Input from '../controls/Input';
import { Authenticate } from '../../configurations/crud/authenticationCrud';
import { setLoginInfo } from '../../configurations/auth/setLoginInfo';
import { useFormik } from 'formik';
import * as yup from 'yup'
import { Link, redirect, useNavigate } from 'react-router-dom';
import LodingButton from '../controls/LodingButton';
import { useToast } from '../controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';
import { FaUserDoctor } from "react-icons/fa6";

import Footer from '../base/Footer';
import useGlobalLoader from '../../configurations/useGlobalLoader';
const schema = yup.object().shape({
    userName: yup.string().required("User name is required"),
    password: yup.string().required("Password is required.")
})
export default function Login() {
    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [isLogin, setIsLogin] = useContext(authContext);
    const [loding, setLoding] = useState(false)
    const navigate = useNavigate()

    const { values, handleChange, handleBlur, handleSubmit, errors, touched, isValid } = useFormik({
        initialValues: {
            userName: "",
            password: "",
        },
        validationSchema: schema,
        onSubmit(values) {
            getlogin(values)
        }
    })

    const getlogin = (val) => {
        setLoding(true)
        start()
        Authenticate(val.userName, val.password).then(res => {
            let data = res.data
            if (data && data.result.succeeded) {
                setLoginInfo(JSON.stringify(data))
                setIsLogin(true)
                redirect("/home")
                setLoding(false)
                end()
            } else {
                toast.open(data.result.message, <MdErrorOutline />, "danger")
                setLoding(false)
                end()
            }
        }).catch(error => {
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }
    return (
        <>
            {isLogin ?

                <h1>Loged In</h1>
                :
                <div className="flex flex-col justify-center min-h-screen py-4 px-6 lg:px-8 bg-slate-100 ">
                    <Link to="/" className="mx-auto w-full max-w-sm mb-3">
                        <img
                            alt="Doctora OPD"
                            src="/assets/images/logo.png"
                            className="mx-auto h-16 w-auto"
                        />
                    </Link>
                    <div className="mx-auto w-full max-w-sm p-6 border-sky-400 shadow-xl hover:shadow-2xl rounded-3xl border-t-4 bg-white">
                        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                            <h2 className="text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                                Sign in to your account
                            </h2>
                        </div>
                        <form onSubmit={handleSubmit} autoComplete='off'>
                            <div className="mt-5 sm:mx-auto sm:w-full sm:max-w-sm ">
                                <div className="space-y-6">
                                    <div>
                                        <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                            Mobile no.
                                        </label>
                                        <div className="mt-2">
                                            <Input tabIndex={1} placeholder="Enter mobile no."
                                                id="userName"
                                                Icon={<FaUserDoctor className='text-green-500' icon={faUser} />}
                                                value={values.userName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isError={errors.userName && touched.userName}
                                            />
                                            {errors.userName && touched.userName && <p className='text-red-600 text-xs'>{errors.userName}</p>}
                                        </div>
                                    </div>

                                    <div>
                                        <div className="flex items-center justify-between">
                                            <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                                                Password
                                            </label>
                                            <div className="text-sm flex gap-1">
                                                <Link tabIndex={5} to="/create-doctor" className="hyper-link">
                                                    Register
                                                </Link>
                                                <span className="hyper-link">|</span>
                                                <Link tabIndex={6} to="/forgot" className="hyper-link">
                                                    Forgot password?
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="mt-2">
                                            <Input tabIndex={2} type="password"
                                                id="password"
                                                placeholder="Enter password"
                                                Icon={<FontAwesomeIcon className='text-sky-500' icon={faLock} />}
                                                value={values.password}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isError={errors.password && touched.password}
                                            />
                                            {errors.password && touched.password && <p className='text-red-600 text-xs'>{errors.password}</p>}
                                        </div>
                                    </div>

                                    <div className='flex gap-2'>
                                        {!loding ?
                                            <>
                                                <button tabIndex={3} className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid} type='submit'>
                                                    Sign in
                                                </button>
                                                <button tabIndex={4} onClick={() => navigate("/")} className={"btn-default"} type='button'>
                                                    Back
                                                </button>
                                            </>
                                            :
                                            <LodingButton text={"Signing In.."} />
                                        }
                                    </div>
                                </div>
                                <p className="-mx-6 -mb-6 mt-6 text-center text-sm text-gray-500">
                                    <Footer isForLogin={true} />
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            }


        </>
    )
}
